import React from "react";
import styled from "styled-components";
import { Container, LinkedInLogo } from "./reusable_components";

const DesignationH1 = styled.h1`
  color: #fff;
  letter-spacing: 2px;
  margin-bottom: 2px;
`;
const DesignationSpan = styled.span`
  color: #fff;
  display: inline-flex;
  margin-bottom: 75px;
  align-items: center;
  @media screen and (max-width: 770px) {
    font-size: 10px;
  }
`;
const DesignationPara = styled.p`
  width: 70%;
  color: #fff;
  letter-spacing: 2px;
  @media (max-width: 770px) {
    font-size: 14px;
    width: 95%;
  }
`;
const Designation = () => {
  return (
    <Container>
      <DesignationH1>I'm a Software Engineer.| </DesignationH1>
      <DesignationSpan>
        Currently, I'm looking for Frontend Developer Job
      </DesignationSpan>
      <DesignationPara data-aos="fade-in">
        A results-driven Front-End Developer with a passion for crafting
        engaging user experiences using ReactJS. Proficient in HTML, CSS,
        JavaScript, and other front-end technologies. Adept at collaborating
        with{" "}
        <span style={{ color: "#7127BA", display: "inline-block" }}>
          cross-functional
        </span>{" "}
        teams to bring projects from concept to completion. Seeking a
        challenging role to contribute my skills and continue learning in a
        dynamic work environment.
      </DesignationPara>
    </Container>
  );
};

export default Designation;
